import { toProxy } from '@fanfanlo'
import _ from 'lodash'
import {storeUtils} from '@fanfanlo'
export interface IPackageInfo{
    label:string
    iconBase64:string
    packageName:string
}
const s = storeUtils.namespace('app-packages')
// s.clear()
interface IData{
    list:IPackageInfo[]
}
const data = toProxy<IData>({list:[]})
loadPackages()
function loadPackages(){
    const list = (s.read('list') || []) as IPackageInfo[]
    data.list = _.isArray(list) ? list : []
}

function releasePackages(){
    data.list = []
}

function savePackages(list:IPackageInfo[]){
    s.write('list', list)
    data.list = list
}

function findPackageInfoByPackageName(packageName:string){
    return data.list.find(item=>item.packageName === packageName)
}
export const appPackagesStore = {
    data,
    loadPackages,
    releasePackages,
    savePackages,
    findPackageInfoByPackageName
}